<template>
    <rkm-content>
        <rkm-content-header :title="$route.meta.title">
            <template v-slot:actions>
                <rkm-button
                    v-if="authorize('administracao-configuracao-sistema-update')"
                    :disabled="loading"
                    @click="$refs.Form.save()"
                    color="success"
                >
                    Salvar
                </rkm-button>
            </template>
        </rkm-content-header>

        <rkm-content-body>
            <rkm-container>
                <Form
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-container>
        </rkm-content-body>
    </rkm-content>
</template>

<script>
// Components.
import Form from '@/components/administracao/configuracao-sistema/Form'

// Mixins.
import {authorization, notification} from '@/mixins'

// Vuex.
import {mapGetters} from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('administracao-configuracao-sistema-form')
        },
    },
    methods: {
        handleSave() {
            this.showSuccessNotification()
        },
    },
    mixins: [authorization, notification],
}
</script>